<script setup lang="ts">
defineProps<{
    content: Record<string, string | null>;
}>();
</script>

<template>
    <section class="bg-secondary px-4 py-16 md:px-20">
        <h2
            class="mb-8 text-center font-serif text-[35px] leading-[49px] text-primary md:mb-16 md:text-[45px] md:leading-[52.8px]"
        >
            {{ content['info.heading'] }}
        </h2>

        <div
            class="mx-auto flex max-w-[1274px] flex-col gap-4 md:flex-row md:gap-[34px]"
        >
            <!-- Ear A-Z Card -->
            <div
                class="relative h-[300px] overflow-hidden rounded-lg md:h-[435px] md:flex-1"
            >
                <img
                    src="/images/landing/home-ear-a-z.webp"
                    alt="Makere, a Resonate subscriber, beside a carved Māori figure"
                    class="absolute inset-0 size-full object-cover"
                />
                <div
                    class="absolute inset-0 rounded-lg"
                    style="
                        background: linear-gradient(
                            39.5deg,
                            rgba(0, 0, 0, 0.8) 4.3%,
                            rgba(0, 0, 0, 0.8) 16.6%,
                            rgba(102, 102, 102, 0) 75.4%
                        );
                    "
                />

                <div class="absolute inset-x-0 bottom-0 p-6">
                    <h3
                        class="text-[24px] leading-[28px] font-medium text-white md:text-[35px] md:leading-[35px]"
                    >
                        {{ content['info.card_1.heading'] }}
                    </h3>
                    <p
                        class="mt-2 text-sm leading-5 font-medium text-white md:mt-3 md:text-base md:leading-6"
                    >
                        {{ content['info.card_1.description'] }}
                    </p>
                    <a
                        :href="content['info.card_1.cta.href'] ?? ''"
                        class="mt-4 inline-flex h-[50px] w-full items-center justify-center rounded-full bg-accent text-sm font-medium text-accent-foreground transition-opacity hover:opacity-90 md:mt-6 md:h-[58px] md:w-[200px] md:text-base"
                    >
                        {{ content['info.card_1.cta.label'] }}
                    </a>
                </div>
            </div>

            <!-- Free Hearing Guide Card -->
            <div
                class="relative h-[300px] overflow-hidden rounded-lg md:h-[435px] md:flex-1"
            >
                <img
                    src="/images/landing/hearing-guide.jpg"
                    :alt="content['info.card_2.heading'] ?? ''"
                    class="absolute inset-0 size-full object-cover"
                />
                <div
                    class="absolute inset-0 rounded-lg"
                    style="
                        background: linear-gradient(
                            58.7deg,
                            rgb(13, 38, 61) 26.7%,
                            rgba(35, 102, 163, 0) 76.4%
                        );
                    "
                />

                <div class="absolute inset-x-0 bottom-0 p-6">
                    <h3
                        class="text-[24px] leading-[28px] font-medium text-white md:text-[35px] md:leading-[35px]"
                    >
                        {{ content['info.card_2.heading'] }}
                    </h3>
                    <p
                        class="mt-2 text-sm leading-5 font-medium text-white md:mt-3 md:max-w-[397px] md:text-base md:leading-6"
                    >
                        {{ content['info.card_2.description'] }}
                    </p>
                    <a
                        :href="content['info.card_2.cta.href'] ?? ''"
                        class="mt-4 inline-flex h-[50px] w-full items-center justify-center rounded-full border border-white text-sm font-medium text-white transition-opacity hover:opacity-90 md:mt-6 md:h-[58px] md:w-[200px] md:text-base"
                    >
                        {{ content['info.card_2.cta.label'] }}
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>
